import type {Component} from "vue";
import {DxPopup} from "devextreme-vue/popup";
import type {messageBoxButtons, messageBoxIcon} from "../components/dialogs/message-box";
import MessageBox from "../components/dialogs/MessageBox.vue";


type OnModalShownCallback = (request: {
    component: Component,
    props?: Record<string, unknown>,
    popupProps?: Omit<DxPopup, "toolbarItems">,
    promiseResolver: (value: unknown) => void
}) => void;

let instance: ReturnType<typeof useModalServiceInternal> | null;
const defaultPopupOptions: Omit<DxPopup, "toolbarItems"> = {dragEnabled: false, hideOnOutsideClick: false};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useModalServiceInternal() {

    let onModalShownCallback: OnModalShownCallback | undefined;

    function showModal(component: Component, props?: Record<string, unknown>, popupProps?: Omit<DxPopup, "toolbarItems">): Promise<unknown> {
        return new Promise((resolve, reject) => {
            if (onModalShownCallback)
                onModalShownCallback({component, props, popupProps: {...popupProps, ...defaultPopupOptions}, promiseResolver: resolve})
            else
                reject();
        });
    }

    function messageBox(content: string, title: string, buttons: messageBoxButtons, icon: messageBoxIcon, isHtml?: boolean, width?: number, height?: number): Promise<unknown> {
        return showModal(MessageBox, {content, buttons, icon, isHtml}, {
            width: width ?? "500", height: height ?? "auto", title: title, showTitle: true, showCloseButton: false
        });
    }


    function onModalShowRequest(callback: OnModalShownCallback) : void {
        onModalShownCallback = callback;
    }

    // noinspection JSUnusedGlobalSymbols
    return {
        showModal,
        messageBox,
        onModalShowRequest: onModalShowRequest
    }
}

export function useModalService() : ReturnType<typeof useModalServiceInternal> {
    if (instance == null)
        instance = useModalServiceInternal();
    return instance;
}